export default "__VITE_ASSET__D0FGGN6n__"